import { FC } from "react";
import FlexBox from "./flex-box";

interface UnavailableOverlayProps {
  message?: string;
}
const UnavailableOverlay: FC<UnavailableOverlayProps> = ({
  message = "Feature not available",
}) => {
  return (
    <FlexBox
      className="w-100 h-100 unavailable-overlay"
      justifyContent="center"
      alignItems="center"
    >
      <h1 className="text-white">{message}</h1>
    </FlexBox>
  );
};
export default UnavailableOverlay;
